/* @flow */
import React from 'react';
import { Route } from 'react-router-dom';
import { translate } from 'react-i18next';
import withRouteTracker from 'common/middleware/RouteTracker';
import { Title } from 'common/components/common';

import { EntityMgmtHeader } from 'common/containers/AppHeaderContainer';

import {
    withRoutePermissionCheck,
    RoleOperationEnum
} from 'common/modules/rbac';

import Products from 'common/enums/Product';

import SectionWrap from 'common/components/common/SectionWrap';
import { type GetRoutesFn } from './types';

import { lazy } from 'common/modules/mfe';

const NetOptEntityManagementContainer = lazy(() =>
    import('netopt-app/routes/NetOptEntityRouteContainer')
);
const NetOptEntityManagementSection = translate()(props => {
    return (
        <SectionWrap>
            <Title i18nKey="nodeIqDataDashboard" />
            <EntityMgmtHeader {...props} />
            <NetOptEntityManagementContainer {...props} />
        </SectionWrap>
    );
});

const NetOptContainer = lazy(() =>
    import('netopt-app/routes/OptimisationRouteContainer')
);
const TrackedNetOptSection = withRouteTracker(
    withRoutePermissionCheck(
        translate()(props => {
            return (
                <SectionWrap>
                    <Title i18nKey="netOptDashboard" />
                    <NetOptContainer {...props} />
                </SectionWrap>
            );
        }),
        [RoleOperationEnum.GET_PROJECTS, RoleOperationEnum.GET_STUDIES]
    ),
    Products.NETWORK_OPTIMIZATION
);

const DigitalTwinContainer = lazy(() =>
    import('netopt-app/routes/DigitalTwinRouteContainer')
);
const TrackedDigitalTwinContainer = withRouteTracker(
    withRoutePermissionCheck(({ ...rest }) => {
        return (
            <SectionWrap>
                <Title i18nKey="digitalTwinDashboard" />
                <DigitalTwinContainer {...rest} />
            </SectionWrap>
        );
    }, RoleOperationEnum.VIEW_DIGITAL_TWIN),
    Products.NETWORK_OPTIMIZATION
);

const getRoutes: GetRoutesFn = ({ match, visibleSections }) => {
    return [
        /* Network Optimization Start*/
        visibleSections.showNetOptSection && (
            <Route
                path={`${match.path}/netOptEntity`}
                component={NetOptEntityManagementSection}
            />
        ),
        visibleSections.showNetOptSection && (
            <Route
                path={`${match.path}/digitalTwin`}
                component={TrackedDigitalTwinContainer}
            />
        ),

        visibleSections.showNetOptSection && (
            <Route
                path={`${match.path}/netOpt`}
                component={TrackedNetOptSection}
            />
        )
    ].filter(Boolean);
};

export default getRoutes;
